import { __rest } from "tslib";
import { Dropdown, Menu, Button } from 'antd';
import React from 'react';
import { apiHolder as api } from 'api';
import { downloadImg } from '@web-mail/components/ReadMail/utils/download-img';
import { handleCopyImg } from '@web-mail/components/ReadMail/utils/handle-copy-img';
import styles from './contextmenu.module.scss';
import { getIn18Text } from 'api';
const systemApi = api.api.getSystemApi();
const ImgContextMenu = ({ src, name, children, ext, downloadBanned }) => {
    if (!systemApi.isElectron() || downloadBanned) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(Dropdown, { overlayStyle: process.env.BUILD_ISPREVIEWPAGE ? { zIndex: 10000 } : {}, overlay: React.createElement(Menu, { className: styles.dropdownMenu },
            React.createElement(Menu.Item, { key: "1", onClick: async () => {
                    handleCopyImg(undefined, src, ext);
                } },
                React.createElement(Button, null, getIn18Text('FUZHITUPIAN'))),
            React.createElement(Menu.Item, { key: "2", onClick: () => {
                    downloadImg(src, name);
                } }, getIn18Text('XIAZAITUPIAN'))), trigger: ['contextMenu'] }, children));
};
ImgContextMenu.defaultProps = {
    src: '',
    name: '',
    ext: '',
    downloadBanned: false,
};
export const withImageContext = (ImageComponent) => class extends React.PureComponent {
    render() {
        const { src, alt, ext } = this.props;
        const _a = this.props, { originSrc } = _a, myProps = __rest(_a, ["originSrc"]);
        return (React.createElement(ImgContextMenu, { src: originSrc || src, name: alt, ext: ext },
            React.createElement(ImageComponent, Object.assign({}, myProps))));
    }
};
export default ImgContextMenu;
